/* istanbul ignore file */

/* tslint:disable */

/* eslint-disable */
export var PaymentOperationKey;

(function (PaymentOperationKey) {
  PaymentOperationKey["UK"] = "UK";
  PaymentOperationKey["US"] = "US";
  PaymentOperationKey["EU"] = "EU";
})(PaymentOperationKey || (PaymentOperationKey = {}));